
export class VolunteerTaskSeries {
    
    static readonly DEFAULT_TASK_DURATION_HRS = 24*7;
    static readonly DEFAULT_TASK_INTERVAL_HRS = 24*7;
    static readonly MAX_CNT = 6;

    id: number | null = null;
    startDate: Date | null = null;
    maxCnt: number | null = null;
    defaultDurationHrs: number | null = null;
    defaultIntervalHrs: number | null = null;
};

// export class VolunteerTaskSeriesView extends VolunteerTaskSeries {
//     missingCnt: number | null = null; // how many tasks are still needed in the series
//     nextScheduledDate: Date | null = null;
    
//     // details about latest task
//     taskId: number | null = null;
//     taskScheduledDate: Date | null = null;
//     taskEndDate: Date | null = null;
//     taskPosition: number | null = null;    
// };
